/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST

export const getProjectTable = params => {
  return axios.post(`${base}/query_project`, params)
}
export const getBaiscProjectTable = params => {
  return axios.post(`${base}/basic-info/query_project`, params)
}
export const getAllProjectTable = params => {
  return axios.post(`${base}/query_all_project`, params)
}
export const exportProjectTable = params => {
  return axios.post(`${base}/export_project`, params)
}
export const getProjectDetail = params => {
  return axios.get(`${base}/project_${params.id}`)
}
export const getProjectName = params => {
  return axios.post(`${base}/project_base_on_name`, params)
}

// 查询预收款开票虚拟项目信息列表
// export const getReceiptVirtualProjectTable = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/query_virtual_project`, params)
// }
export const getReceiptVirtualProjectTable = params => {
  return axios.post(`${finBase}/receipt-applications/advances/virtual-projects/lists`, params)
}
// 查询预收款开票虚拟项目信息详情
// export const getReceiptVirtualProjectDetail = params => {
//   return axios.get(`${base}/receipt-apply/pre_received/virtual_project_${params.id}`, {params})
// }
export const getReceiptVirtualProjectDetail = params => {
  return axios.get(`${finBase}/receipt-applications/advances/virtual-projects/${params.id}`, {params})
}

export const queryProjectProgressTableApi = params => {
  return axios.post(`${base}/project_progress/query`, params)
}
export const queryProjectNodeSnapshotApi = params => {
  return axios.post(`${base}/project_progress/snapshots`, params)
}
export const exportProjectProgressTableApi = params => {
  return axios.post(`${base}/project_progress/export`, params)
}
export const getProjectProgressDetailApi = params => {
  return axios.get(`${base}/project_progress/get_by_project/${params.id}`, {params})
}
export const editProgressShowStatusApi = params => {
  return axios.post(`${base}/project_progress/edit_show_status/${params.id}`, params)
}
// 上传客户清单
export const uploadCustomerListApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/upload_customer_clear_files`, params)
}
// 成本确认
export const addProjectCostConfirmApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/add_project_cost_confirm`, params)
}
export const auditPassProjectCostApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/audit_pass_project_cost`, params)
}
export const auditRejectProjectCostApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/audit_reject_project_cost`, params)
}
export const getProjectCostApi = params => {
  return axios.get(`${base}/project_progress/${params.id}/get_project_cost`, {params})
}
// 添加启动会时间
export const addKickoffMeetingTimeApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/add_kickoff_meeting`, params)
}
// 上传清洗后的文件
export const uploadCleanedFilesApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/upload_cleaned_files`, params)
}
// 添加进度分享会时间
export const addShareMeetingTimeApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/add_progress_share_meeting`, params)
}
// 上传报告附件
export const uploadProjectReportApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/upload_project_report`, params)
}
// 添加复盘会时间
export const addReviewMeetingTimeApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/add_review_meeting`, params)
}
// 保存BO Header评分
export const saveBoHeaderScoreApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/save_bo_header_score`, params)
}
export const saveFirstScoreApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/save_first_audit_score`, params)
}
export const saveSecondScoreApi = params => {
  return axios.post(`${base}/project_progress/${params.id}/save_second_audit_score`, params)
}



// WEBPACK FOOTER //
// ./src/views/project/project.api.js